import { enumLanguage } from "@configs";
import { IMerchant } from "@interfaces";
import { selectApp } from "@redux";
import { Skeleton } from "antd";
import { MouseEvent, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

interface CustomOtherMenuProps {
    merchant: IMerchant;
    token: any;
    history: any;
    isloadding: any;
}

export default function CustomOtherMenu({
    merchant,
    token,
    history,
    isloadding,
}: CustomOtherMenuProps) {
    const i18nextLng = window.localStorage.i18nextLng;
    const [isLoading, setIsloading] = useState(false);
    const { lang } = useSelector(selectApp);

    const themeColor = merchant.themes?.themeColor;

    // const rightCircle = merchant.customizeProfile.rightCircle;

    const rightCircle = merchant.themes?.customizeProfile.rightCircle;

    const handleClickMenu = (path: string) => {
        if (!path) return;

        if (path[0] === "/") {
            history.push(path);
        } else if (
            path.includes("pos-client") ||
            path.includes("service-client") ||
            path.includes("rocket-ecommerce") ||
            path.includes("fudidiworld") ||
            path.includes("drpongskinclub") ||
            path.includes("rocket-booking") ||
            path.includes("eventease")
        ) {
            let originUrl = new URL(path).origin;
            let pathName = new URL(path).pathname;
            window.open(
                `${originUrl}/auth/${token}?lang=${
                    lang === "THAI" ? "th" : "en"
                }&redirect=${pathName}`,
                "_self"
            );
        } else {
            window.open(path, "_self");
        }
    };

    const resolveMenuPath = (item: any) => item?.linkWeb || item?.linkweb || "";
    const preventDefaultLinkNavigation = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
    };

    return (
        <>
            <div className="wrapper-content-slide">
                {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB ? (
                    <Swiper slidesPerView={4.5} spaceBetween={20} pagination={true}>
                        {merchant?.themes?.isOtherMenu &&
                            merchant?.themes?.otherMenu?.map((item: any, index: any) => (
                                <SwiperSlide key={index}>
                                    <Skeleton
                                        loading={isLoading}
                                        active
                                        title={false}
                                        avatar={{ shape: "circle" }}
                                        paragraph={{
                                            rows: 2,
                                            width: [66, 42],
                                        }}
                                    >
                                        <div
                                            className="layout-content-slide"
                                            onClick={() => handleClickMenu(resolveMenuPath(item))}
                                        >
                                            <div className="img-content-slide">
                                                <a
                                                    href={resolveMenuPath(item)}
                                                    onClick={preventDefaultLinkNavigation}
                                                >
                                                    <img src={item.icon} alt="coverpromotion" />
                                                </a>
                                            </div>
                                            <a
                                                href={resolveMenuPath(item)}
                                                onClick={preventDefaultLinkNavigation}
                                            >
                                                {item.titleMenu}
                                            </a>
                                            <p>{item.descripMenu}</p>
                                            {item.isHighLight && (
                                                <div className="layout-hot-content">
                                                    <StyledHighLight
                                                        themeColor={themeColor!}
                                                        color={item.highLightColor}
                                                    >
                                                        {item.highLight}
                                                    </StyledHighLight>
                                                </div>
                                            )}
                                        </div>
                                    </Skeleton>
                                </SwiperSlide>
                            ))}
                    </Swiper>
                ) : (
                    <>
                        <Swiper slidesPerView={4.5} spaceBetween={20} pagination={true}>
                            {merchant?.themes?.isOtherMenu &&
                                merchant?.themes?.otherMenu?.map((item: any, index: any) => (
                                    <SwiperSlide key={index}>
                                        <Skeleton
                                            loading={isLoading}
                                            active
                                            title={false}
                                            avatar={{ shape: "circle" }}
                                            paragraph={{
                                                rows: 2,
                                                width: [66, 42],
                                            }}
                                        >
                                            <div
                                                className="layout-content-slide"
                                                onClick={() => handleClickMenu(resolveMenuPath(item))}
                                            >
                                                <div className="img-content-slide">
                                                    <a
                                                        href={resolveMenuPath(item)}
                                                        onClick={preventDefaultLinkNavigation}
                                                    >
                                                        <img src={item.icon} alt="coverpromotion" />
                                                    </a>
                                                </div>
                                                <a
                                                    href={resolveMenuPath(item)}
                                                    onClick={preventDefaultLinkNavigation}
                                                >
                                                    {item.titleMenuTh}
                                                </a>
                                                <p>{item.descripMenuTh}</p>
                                                {item.isHighLight && (
                                                    <div className="layout-hot-content">
                                                        <StyledHighLight
                                                            themeColor={themeColor!}
                                                            color={item.highLightColor}
                                                        >
                                                            {item.highLight}
                                                        </StyledHighLight>
                                                    </div>
                                                )}
                                            </div>
                                        </Skeleton>
                                    </SwiperSlide>
                                ))}
                        </Swiper>
                    </>
                )}
            </div>
        </>
    );
}

//#region Styles

const StyledHighLight = styled.span<{ themeColor: string }>`
    position: relative;
    color: #fff;
    background-color: ${(props) => props.color || props.themeColor};

    font-size: 12px;
    line-height: 14px;
    padding: 4px 8px 6px;
    border-radius: 4px;
    z-index: 2;
    &:after {
        content: "";
        width: 7px;
        height: 7px;
        background-color: ${(props) => props.color || props.themeColor};
        position: absolute;
        bottom: -6px;
        left: 50%;
        rotate: 45deg;
        transform: translateX(-50%);
        z-index: 1;
    }
`;

const StyledColorTier = styled.p`
    color: ${(props) => props.color || "#000"};
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 70px;
    font-weight: 600;
    text-align: center;
`;

const StlyedMemberType = styled.div<{ themeColor: string }>`
    display: flex;
    width: 60px;
    height: 60px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 5px solid ${(p) => p.themeColor};
    img {
        width: 35px;
        height: auto;
    }
`;

const StyledDotCircular = styled.div<{ rotatevalue: string; colortier: string | undefined }>`
    transform: rotate(${(props) => (parseInt(props.rotatevalue) * 360) / 100 + "deg" || 0 + "deg"});
    position: absolute;
    .dot-circular {
        width: 6px;
        height: 6px;
        background-color: ${(props) => props.colortier};
        transform: translateY(-40px);
        border-radius: 100%;
    }
`;

//#endregion
